import { useState } from "react";

import { Building2, BriefcaseBusiness } from "lucide-react";

import { createBusiness } from "../services/business";

import { useNavigate } from "react-router-dom";

export function BusinessDetails() {

    const [formData, setFormData] = useState({

        businessName: "",
        businessType: ""

    });

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    function handleChange(event) {

        const { name, value } = event.target;

        setFormData(previous => ({
            ...previous,
            [name]: value
        }));

    }

    async function handleSubmit(event) {

        event.preventDefault();

        if (loading) {
            return;
        }

        try {

            setLoading(true);

            await createBusiness({

                businessName: formData.businessName.trim(),
                businessType: formData.businessType

            });

            navigate("/outlet-details");

        } catch (error) {

            console.error(error);

            setLoading(false);

        }

    }

    return (

        <>
            <header className="setup-header">

                <div className="setup-header-logo">

                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="NextGo Logo"
                        className="setup-header-logo-icon"
                    />

                    <span className="setup-header-logo-text">
                        Next<span className="blue">Go</span>
                    </span>

                </div>

            </header>

            <main className="business-details-page">

                <div className="business-details-layout">

                    <aside className="setup-sidebar">

                        <div>

                            <span className="setup-badge">
                                Step 1 of 3
                            </span>

                            <h1>
                                Let's set up your business
                            </h1>

                            <p>
                                Tell us about your business.
                                This only takes a couple of minutes.
                            </p>

                        </div>

                        <div className="setup-progress">

                            <div className="setup-step active">

                                <div className="setup-step-number">
                                    1
                                </div>

                                <div>

                                    <h3>
                                        Business Details
                                    </h3>

                                    <p>
                                        Tell us about your business
                                    </p>

                                </div>

                            </div>

                            <div className="setup-step">

                                <div className="setup-step-number">
                                    2
                                </div>

                                <div>

                                    <h3>
                                        First Outlet
                                    </h3>

                                    <p>
                                        Add your first outlet
                                    </p>

                                </div>

                            </div>

                            <div className="setup-step">

                                <div className="setup-step-number">
                                    3
                                </div>

                                <div>

                                    <h3>
                                        Integrations
                                    </h3>

                                    <p>
                                        Connect Shopify or Petpooja
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div className="setup-tip">

                            <strong>
                                Tip
                            </strong>

                            <p>
                                You can always add more outlets and integrations later.
                            </p>

                        </div>

                    </aside>

                    <section className="business-details-card">

                        <form
                            onSubmit={handleSubmit}
                        >

                            <span className="setup-card-step">
                                Step 1 of 3
                            </span>

                            <h2>
                                Business Details
                            </h2>

                            <p className="setup-description">
                                This information helps us customize NextGo for your business.
                            </p>

                            <div className="form-group">

                                <label>
                                    Business Name
                                </label>

                                <div className="input-with-icon">

                                    <Building2 size={18} />

                                    <input
                                        type="text"
                                        name="businessName"
                                        placeholder="e.g. Punjabi Tadka"
                                        value={formData.businessName}
                                        onChange={handleChange}
                                    />

                                </div>

                                <small>
                                    This is the legal name of your business.
                                </small>

                            </div>

                            <div className="form-group">

                                <label>
                                    Business Type
                                </label>

                                <div className="input-with-icon">

                                    <BriefcaseBusiness size={18} />

                                    <select
                                        name="businessType"
                                        value={formData.businessType}
                                        onChange={handleChange}
                                    >

                                        <option value="">
                                            Select your business type
                                        </option>

                                        <option value="restaurant">
                                            Restaurant
                                        </option>

                                        <option value="cafe">
                                            Cafe
                                        </option>

                                        <option value="qsr">
                                            QSR
                                        </option>

                                        <option value="super-market">
                                            Super Market
                                        </option>

                                        <option value="retail">
                                            Retail
                                        </option>

                                        <option value="ecommerce">
                                            E-commerce
                                        </option>

                                        <option value="salon">
                                            Salon
                                        </option>

                                        <option value="other">
                                            Other
                                        </option>

                                    </select>

                                </div>

                                <small>
                                    Choose the option that best describes your business.
                                </small>

                            </div>

                            <div className="setup-actions">

                                {/* <button
                                    type="button"
                                    className="secondary-button"
                                >
                                    Cancel
                                </button> */}

                                <button
                                    type="submit"
                                    className="primary-button"
                                >
                                    Continue
                                </button>

                            </div>

                        </form>

                    </section>

                </div>

            </main>

        </>

    );

}